/**
 * Command types for the Mission Control ↔ CLI protocol.
 * Includes prompt response types and control commands like mode switching.
 *
 * These live here rather than with the agent session constants because the
 * Copilot composers that answer prompts sit below agent sessions.
 */
export const COMMAND_TYPES = {
  ASK_USER_RESPONSE: 'ask_user_response',
  ELICITATION_RESPONSE: 'elicitation_response',
  PLAN_APPROVAL_RESPONSE: 'plan_approval_response',
  PERMISSION_RESPONSE: 'permission_response',
  MODE_SWITCH: 'mode_switch',
  ABORT: 'abort',
} as const

/**
 * Response command type values from COMMAND_TYPES.
 */
type ResponseCommandType = (typeof COMMAND_TYPES)[keyof typeof COMMAND_TYPES]

/**
 * Command types for Mission Control ↔ CLI protocol.
 * These determine how the CLI processes incoming commands.
 */
export type CommandType = 'user_message' | ResponseCommandType
